<template>
  <b-row>
    <b-col cols="12">
      <okr-add-form />
    </b-col>
  </b-row>
</template>

<script>
import { BRow, BCol } from 'bootstrap-vue'
import OkrAddForm from './OkrAddForm.vue'

export default {
  components: {
    BRow,
    BCol,
    OkrAddForm,
  },
}
</script>

<style lang="scss">
    @import '@core/scss/vue/libs/vue-wizard.scss';
    @import '@core/scss/vue/libs/vue-select.scss';
</style>
